import axios from 'axios'
import { showSnackbar, snackbarTypes } from 'src/redux/snackbar'

export const GET_CURRENT_SUBSCRIPTION_LOADING = 'subscription/GET_CURRENT_SUBSCRIPTION_LOADING'
export const GET_CURRENT_SUBSCRIPTION_SUCCESS = 'subscription/GET_CURRENT_SUBSCRIPTION_SUCCESS'
export const GET_CURRENT_SUBSCRIPTION_FAILURE = 'subscription/GET_CURRENT_SUBSCRIPTION_FAILURE'
export const CREATE_BILLING_PORTAL_SESSION_LOADING = 'subscription/CREATE_BILLING_PORTAL_SESSION_LOADING'
export const CREATE_BILLING_PORTAL_SESSION_FAILURE = 'subscription/CREATE_BILLING_PORTAL_SESSION_FAILURE'

export const getCurrentSubscriptionLoading = () => ({
  type: GET_CURRENT_SUBSCRIPTION_LOADING,
})

export const getCurrentSubscriptionSuccess = payload => ({
  type: GET_CURRENT_SUBSCRIPTION_SUCCESS,
  payload,
})

export const getCurrentSubscriptionFailure = () => ({
  type: GET_CURRENT_SUBSCRIPTION_FAILURE,
})

export const createBillingPortalSessionLoading = () => ({
  type: CREATE_BILLING_PORTAL_SESSION_LOADING,
})

export const createBillingPortalSessionFailure = () => ({
  type: CREATE_BILLING_PORTAL_SESSION_FAILURE,
})

export const fetchGetCurrentSubscription = () => async dispatch => {
  dispatch(getCurrentSubscriptionLoading())
  try {
    const response = await axios({
      method: 'GET',
      url: '/api/subscriptions/current',
    })
    dispatch(getCurrentSubscriptionSuccess(response.data))
  } catch (error) {
    dispatch(getCurrentSubscriptionFailure())
  }
}

export const fetchCreateBillingPortalSession = () => async dispatch => {
  dispatch(createBillingPortalSessionLoading())
  try {
    const response = await axios({
      method: 'POST',
      url: '/api/subscriptions/billing_portal_session',
    })
    window.location.href = response.data.portalUrl
  } catch (error) {
    dispatch(createBillingPortalSessionFailure())
    dispatch(showSnackbar('Unable to open billing management. Please try again later.', snackbarTypes.ERROR))
  }
}

const initialState = {
  loading: false,
  loaded: false,
  billingPortalLoading: false,
  hasSubscription: false,
  isOwnSubscription: false,
  planName: null,
  status: null,
  currentPeriodEnd: null,
  cancelAtPeriodEnd: false,
  priceAmount: null,
  priceInterval: null,
}

export const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENT_SUBSCRIPTION_LOADING:
      return {
        ...state,
        loading: true,
      }
    case GET_CURRENT_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
        loaded: true,
      }
    case GET_CURRENT_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
      }
    case CREATE_BILLING_PORTAL_SESSION_LOADING:
      return {
        ...state,
        billingPortalLoading: true,
      }
    case CREATE_BILLING_PORTAL_SESSION_FAILURE:
      return {
        ...state,
        billingPortalLoading: false,
      }
    default:
      return state
  }
}
